// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function registrationIdentifierToJson(m) {
    const o = {};
    if (m.identifierType !== undefined)
        o['identifierType'] = m.identifierType;
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function registrationIdentifierFromJson(o) {
    var _a, _b;
    return {
        identifierType: (_a = o['identifierType']) !== null && _a !== void 0 ? _a : '',
        identifier: (_b = o['identifier']) !== null && _b !== void 0 ? _b : '',
    };
}
export function businessToJson(m) {
    const o = {};
    if (m.legalName !== undefined)
        o['legalName'] = m.legalName;
    if (m.businessType !== undefined)
        o['businessType'] = m.businessType;
    if (m.industry !== undefined)
        o['industry'] = m.industry;
    if (m.registrationIdentifier !== undefined)
        o['registrationIdentifier'] = registrationIdentifierToJson(m.registrationIdentifier);
    if (m.regionOfOperation !== undefined)
        o['regionOfOperation'] = m.regionOfOperation;
    if (m.websiteUrl !== undefined)
        o['websiteUrl'] = m.websiteUrl;
    if (m.socialMediaProfileUrls !== undefined) {
        o['socialMediaProfileUrls'] = m.socialMediaProfileUrls.map(e => e);
    }
    if (m.streetAddress !== undefined)
        o['streetAddress'] = m.streetAddress;
    if (m.streetAddressSecondary !== undefined)
        o['streetAddressSecondary'] = m.streetAddressSecondary;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.postalCode !== undefined)
        o['postalCode'] = m.postalCode;
    if (m.country !== undefined)
        o['country'] = m.country;
    return o;
}
export function businessFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        legalName: (_a = o['legalName']) !== null && _a !== void 0 ? _a : '',
        businessType: (_b = o['businessType']) !== null && _b !== void 0 ? _b : '',
        industry: (_c = o['industry']) !== null && _c !== void 0 ? _c : '',
        registrationIdentifier: o['registrationIdentifier'] ? registrationIdentifierFromJson(o['registrationIdentifier']) : undefined,
        regionOfOperation: (_d = o['regionOfOperation']) !== null && _d !== void 0 ? _d : '',
        websiteUrl: (_e = o['websiteUrl']) !== null && _e !== void 0 ? _e : '',
        socialMediaProfileUrls: ((_f = o['socialMediaProfileUrls']) !== null && _f !== void 0 ? _f : []).map(e => e),
        streetAddress: (_g = o['streetAddress']) !== null && _g !== void 0 ? _g : '',
        streetAddressSecondary: (_h = o['streetAddressSecondary']) !== null && _h !== void 0 ? _h : '',
        city: (_j = o['city']) !== null && _j !== void 0 ? _j : '',
        state: (_k = o['state']) !== null && _k !== void 0 ? _k : '',
        postalCode: (_l = o['postalCode']) !== null && _l !== void 0 ? _l : '',
        country: (_m = o['country']) !== null && _m !== void 0 ? _m : '',
    };
}
export function authorizedRepresentativeToJson(m) {
    const o = {};
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.businessTitle !== undefined)
        o['businessTitle'] = m.businessTitle;
    if (m.jobPosition !== undefined)
        o['jobPosition'] = m.jobPosition;
    return o;
}
export function authorizedRepresentativeFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        firstName: (_a = o['firstName']) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = o['lastName']) !== null && _b !== void 0 ? _b : '',
        email: (_c = o['email']) !== null && _c !== void 0 ? _c : '',
        phoneNumber: (_d = o['phoneNumber']) !== null && _d !== void 0 ? _d : '',
        businessTitle: (_e = o['businessTitle']) !== null && _e !== void 0 ? _e : '',
        jobPosition: (_f = o['jobPosition']) !== null && _f !== void 0 ? _f : '',
    };
}
export function campaignInfoToJson(m) {
    const o = {};
    if (m.privacyPolicyUrl !== undefined)
        o['privacyPolicyUrl'] = m.privacyPolicyUrl;
    if (m.termsAndConditionsUrl !== undefined)
        o['termsAndConditionsUrl'] = m.termsAndConditionsUrl;
    if (m.smsUsage !== undefined)
        o['smsUsage'] = m.smsUsage;
    if (m.collectsVerbalConsent !== undefined)
        o['collectsVerbalConsent'] = m.collectsVerbalConsent;
    if (m.verbalConsentScript !== undefined)
        o['verbalConsentScript'] = m.verbalConsentScript;
    if (m.hasWebchatWidget !== undefined)
        o['hasWebchatWidget'] = m.hasWebchatWidget;
    if (m.webchatWidgetUrl !== undefined)
        o['webchatWidgetUrl'] = m.webchatWidgetUrl;
    if (m.hasWebForm !== undefined)
        o['hasWebForm'] = m.hasWebForm;
    if (m.webFormUrl !== undefined)
        o['webFormUrl'] = m.webFormUrl;
    return o;
}
export function campaignInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        privacyPolicyUrl: (_a = o['privacyPolicyUrl']) !== null && _a !== void 0 ? _a : '',
        termsAndConditionsUrl: (_b = o['termsAndConditionsUrl']) !== null && _b !== void 0 ? _b : '',
        smsUsage: (_c = o['smsUsage']) !== null && _c !== void 0 ? _c : '',
        collectsVerbalConsent: (_d = o['collectsVerbalConsent']) !== null && _d !== void 0 ? _d : false,
        verbalConsentScript: (_e = o['verbalConsentScript']) !== null && _e !== void 0 ? _e : '',
        hasWebchatWidget: (_f = o['hasWebchatWidget']) !== null && _f !== void 0 ? _f : false,
        webchatWidgetUrl: (_g = o['webchatWidgetUrl']) !== null && _g !== void 0 ? _g : '',
        hasWebForm: (_h = o['hasWebForm']) !== null && _h !== void 0 ? _h : false,
        webFormUrl: (_j = o['webFormUrl']) !== null && _j !== void 0 ? _j : '',
    };
}
export function a2PRegistrationInfoToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.friendlyName !== undefined)
        o['friendlyName'] = m.friendlyName;
    if (m.business !== undefined)
        o['business'] = businessToJson(m.business);
    if (m.authorizedRepresentative !== undefined)
        o['authorizedRepresentative'] = authorizedRepresentativeToJson(m.authorizedRepresentative);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.submitted !== undefined)
        o['submitted'] = m.submitted.toISOString();
    if (m.campaignInfo !== undefined)
        o['campaignInfo'] = campaignInfoToJson(m.campaignInfo);
    return o;
}
export function a2PRegistrationInfoFromJson(o) {
    var _a, _b, _c;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        friendlyName: (_c = o['friendlyName']) !== null && _c !== void 0 ? _c : '',
        business: o['business'] ? businessFromJson(o['business']) : undefined,
        authorizedRepresentative: o['authorizedRepresentative'] ? authorizedRepresentativeFromJson(o['authorizedRepresentative']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        submitted: o['submitted'] ? new Date(o['submitted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        campaignInfo: o['campaignInfo'] ? campaignInfoFromJson(o['campaignInfo']) : undefined,
    };
}
export function secondaryBusinessProfileToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.authorizedRepresentativeId !== undefined)
        o['authorizedRepresentativeId'] = m.authorizedRepresentativeId;
    if (m.addressResourceId !== undefined)
        o['addressResourceId'] = m.addressResourceId;
    if (m.addressSupportingDocumentId !== undefined)
        o['addressSupportingDocumentId'] = m.addressSupportingDocumentId;
    if (m.secondaryBusinessInformationId !== undefined)
        o['secondaryBusinessInformationId'] = m.secondaryBusinessInformationId;
    if (m.fieldsWithIssues !== undefined) {
        o['fieldsWithIssues'] = m.fieldsWithIssues.map(e => e);
    }
    return o;
}
export function secondaryBusinessProfileFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'VALIDATION_STATUS_UNSPECIFIED',
        authorizedRepresentativeId: (_c = o['authorizedRepresentativeId']) !== null && _c !== void 0 ? _c : '',
        addressResourceId: (_d = o['addressResourceId']) !== null && _d !== void 0 ? _d : '',
        addressSupportingDocumentId: (_e = o['addressSupportingDocumentId']) !== null && _e !== void 0 ? _e : '',
        secondaryBusinessInformationId: (_f = o['secondaryBusinessInformationId']) !== null && _f !== void 0 ? _f : '',
        fieldsWithIssues: ((_g = o['fieldsWithIssues']) !== null && _g !== void 0 ? _g : []).map(e => e),
    };
}
export function trustBundleToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.companyId !== undefined)
        o['companyId'] = m.companyId;
    if (m.fieldsWithIssues !== undefined) {
        o['fieldsWithIssues'] = m.fieldsWithIssues.map(e => e);
    }
    return o;
}
export function trustBundleFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'VALIDATION_STATUS_UNSPECIFIED',
        companyId: (_c = o['companyId']) !== null && _c !== void 0 ? _c : '',
        fieldsWithIssues: ((_d = o['fieldsWithIssues']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function brandToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.fieldsWithIssues !== undefined) {
        o['fieldsWithIssues'] = m.fieldsWithIssues.map(e => e);
    }
    return o;
}
export function brandFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'BRAND_STATUS_UNSPECIFIED',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        fieldsWithIssues: ((_c = o['fieldsWithIssues']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function campaignErrorToJson(m) {
    const o = {};
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.errorCode !== undefined)
        o['errorCode'] = m.errorCode;
    if (m.fields !== undefined) {
        o['fields'] = m.fields.map(e => e);
    }
    return o;
}
export function campaignErrorFromJson(o) {
    var _a, _b, _c;
    return {
        description: (_a = o['description']) !== null && _a !== void 0 ? _a : '',
        errorCode: (_b = o['errorCode']) !== null && _b !== void 0 ? _b : 0,
        fields: ((_c = o['fields']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function messagingCampaignToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.messageFlow !== undefined)
        o['messageFlow'] = m.messageFlow;
    if (m.errors !== undefined) {
        o['errors'] = m.errors.map(e => campaignErrorToJson(e));
    }
    return o;
}
export function messagingCampaignFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        messageFlow: (_d = o['messageFlow']) !== null && _d !== void 0 ? _d : '',
        errors: ((_e = o['errors']) !== null && _e !== void 0 ? _e : []).map(e => campaignErrorFromJson(e)),
    };
}
export function a2PRegistrationStatusToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.subaccountId !== undefined)
        o['subaccountId'] = m.subaccountId;
    if (m.messagingServiceId !== undefined)
        o['messagingServiceId'] = m.messagingServiceId;
    if (m.secondaryBusinessProfile !== undefined)
        o['secondaryBusinessProfile'] = secondaryBusinessProfileToJson(m.secondaryBusinessProfile);
    if (m.trustBundle !== undefined)
        o['trustBundle'] = trustBundleToJson(m.trustBundle);
    if (m.brand !== undefined)
        o['brand'] = brandToJson(m.brand);
    if (m.messagingCampaign !== undefined)
        o['messagingCampaign'] = messagingCampaignToJson(m.messagingCampaign);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function a2PRegistrationStatusFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        ownerType: (_c = o['ownerType']) !== null && _c !== void 0 ? _c : 'OWNER_TYPE_UNSPECIFIED',
        subaccountId: (_d = o['subaccountId']) !== null && _d !== void 0 ? _d : '',
        messagingServiceId: (_e = o['messagingServiceId']) !== null && _e !== void 0 ? _e : '',
        secondaryBusinessProfile: o['secondaryBusinessProfile'] ? secondaryBusinessProfileFromJson(o['secondaryBusinessProfile']) : undefined,
        trustBundle: o['trustBundle'] ? trustBundleFromJson(o['trustBundle']) : undefined,
        brand: o['brand'] ? brandFromJson(o['brand']) : undefined,
        messagingCampaign: o['messagingCampaign'] ? messagingCampaignFromJson(o['messagingCampaign']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function participantToJson(m) {
    const o = {};
    if (m.internalId !== undefined)
        o['internalId'] = m.internalId;
    if (m.type !== undefined)
        o['type'] = m.type;
    return o;
}
export function participantFromJson(o) {
    var _a, _b;
    return {
        internalId: (_a = o['internalId']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'PARTICIPANT_TYPE_UNKNOWN',
    };
}
export function attributeToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function attributeFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function supportingDocumentInfoToJson(m) {
    const o = {};
    if (m.documentType !== undefined)
        o['documentType'] = m.documentType;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.fileId !== undefined)
        o['fileId'] = m.fileId;
    if (m.processAddress !== undefined)
        o['processAddress'] = m.processAddress;
    return o;
}
export function supportingDocumentInfoFromJson(o) {
    var _a, _b, _c, _d;
    return {
        documentType: (_a = o['documentType']) !== null && _a !== void 0 ? _a : '',
        attributes: ((_b = o['attributes']) !== null && _b !== void 0 ? _b : []).map(e => attributeFromJson(e)),
        fileId: (_c = o['fileId']) !== null && _c !== void 0 ? _c : '',
        processAddress: (_d = o['processAddress']) !== null && _d !== void 0 ? _d : false,
    };
}
export function rejectionDetailToJson(m) {
    const o = {};
    if (m.resourceSid !== undefined)
        o['resourceSid'] = m.resourceSid;
    if (m.resourceType !== undefined)
        o['resourceType'] = m.resourceType;
    if (m.fieldName !== undefined)
        o['fieldName'] = m.fieldName;
    if (m.failureReason !== undefined)
        o['failureReason'] = m.failureReason;
    if (m.errorCodes !== undefined) {
        o['errorCodes'] = m.errorCodes.map(e => e);
    }
    return o;
}
export function rejectionDetailFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        resourceSid: (_a = o['resourceSid']) !== null && _a !== void 0 ? _a : '',
        resourceType: (_b = o['resourceType']) !== null && _b !== void 0 ? _b : '',
        fieldName: (_c = o['fieldName']) !== null && _c !== void 0 ? _c : '',
        failureReason: (_d = o['failureReason']) !== null && _d !== void 0 ? _d : '',
        errorCodes: ((_e = o['errorCodes']) !== null && _e !== void 0 ? _e : []).map(e => e),
    };
}
export function regulationInfoToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.businessAttributes !== undefined) {
        o['businessAttributes'] = m.businessAttributes.map(e => attributeToJson(e));
    }
    if (m.supportingDocuments !== undefined) {
        o['supportingDocuments'] = m.supportingDocuments.map(e => supportingDocumentInfoToJson(e));
    }
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.rejectionReason !== undefined)
        o['rejectionReason'] = m.rejectionReason;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.rejectionDetails !== undefined) {
        o['rejectionDetails'] = m.rejectionDetails.map(e => rejectionDetailToJson(e));
    }
    return o;
}
export function regulationInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        ownerType: (_c = o['ownerType']) !== null && _c !== void 0 ? _c : 'OWNER_TYPE_UNSPECIFIED',
        countryCode: (_d = o['countryCode']) !== null && _d !== void 0 ? _d : '',
        businessAttributes: ((_e = o['businessAttributes']) !== null && _e !== void 0 ? _e : []).map(e => attributeFromJson(e)),
        supportingDocuments: ((_f = o['supportingDocuments']) !== null && _f !== void 0 ? _f : []).map(e => supportingDocumentInfoFromJson(e)),
        status: (_g = o['status']) !== null && _g !== void 0 ? _g : 'REGULATION_STATUS_UNSPECIFIED',
        rejectionReason: (_h = o['rejectionReason']) !== null && _h !== void 0 ? _h : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        rejectionDetails: ((_j = o['rejectionDetails']) !== null && _j !== void 0 ? _j : []).map(e => rejectionDetailFromJson(e)),
    };
}
export function startCallConfigToJson(m) {
    const o = {};
    if (m.mode !== undefined)
        o['mode'] = m.mode;
    return o;
}
export function startCallConfigFromJson(o) {
    var _a;
    return {
        mode: (_a = o['mode']) !== null && _a !== void 0 ? _a : 'START_CALL_UNSPECIFIED',
    };
}
export function voiceAIConfigToJson(m) {
    const o = {};
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.startCallConfig !== undefined)
        o['startCallConfig'] = startCallConfigToJson(m.startCallConfig);
    return o;
}
export function voiceAIConfigFromJson(o) {
    var _a;
    return {
        enabled: (_a = o['enabled']) !== null && _a !== void 0 ? _a : false,
        startCallConfig: o['startCallConfig'] ? startCallConfigFromJson(o['startCallConfig']) : undefined,
    };
}
export function callForwardingConfigToJson(m) {
    const o = {};
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    return o;
}
export function callForwardingConfigFromJson(o) {
    var _a, _b;
    return {
        phoneNumber: (_a = o['phoneNumber']) !== null && _a !== void 0 ? _a : '',
        enabled: (_b = o['enabled']) !== null && _b !== void 0 ? _b : false,
    };
}
export function missedCallMessagingConfigToJson(m) {
    const o = {};
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.trigger !== undefined)
        o['trigger'] = m.trigger;
    if (m.messageContent !== undefined)
        o['messageContent'] = m.messageContent;
    return o;
}
export function missedCallMessagingConfigFromJson(o) {
    var _a, _b, _c;
    return {
        enabled: (_a = o['enabled']) !== null && _a !== void 0 ? _a : false,
        trigger: (_b = o['trigger']) !== null && _b !== void 0 ? _b : 'MISSED_CALL_TRIGGER_UNSPECIFIED',
        messageContent: (_c = o['messageContent']) !== null && _c !== void 0 ? _c : '',
    };
}
export function endCallMessageToJson(m) {
    const o = {};
    if (m.messageContent !== undefined)
        o['messageContent'] = m.messageContent;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    return o;
}
export function endCallMessageFromJson(o) {
    var _a, _b;
    return {
        messageContent: (_a = o['messageContent']) !== null && _a !== void 0 ? _a : '',
        enabled: (_b = o['enabled']) !== null && _b !== void 0 ? _b : false,
    };
}
export function phoneNumberConfigToJson(m) {
    const o = {};
    if (m.callForwarding !== undefined)
        o['callForwarding'] = callForwardingConfigToJson(m.callForwarding);
    if (m.missedCallMessaging !== undefined)
        o['missedCallMessaging'] = missedCallMessagingConfigToJson(m.missedCallMessaging);
    if (m.voiceAi !== undefined)
        o['voiceAi'] = voiceAIConfigToJson(m.voiceAi);
    if (m.endCallMessage !== undefined)
        o['endCallMessage'] = m.endCallMessage;
    if (m.endCall !== undefined)
        o['endCall'] = endCallMessageToJson(m.endCall);
    return o;
}
export function phoneNumberConfigFromJson(o) {
    var _a;
    return {
        callForwarding: o['callForwarding'] ? callForwardingConfigFromJson(o['callForwarding']) : undefined,
        missedCallMessaging: o['missedCallMessaging'] ? missedCallMessagingConfigFromJson(o['missedCallMessaging']) : undefined,
        voiceAi: o['voiceAi'] ? voiceAIConfigFromJson(o['voiceAi']) : undefined,
        endCallMessage: (_a = o['endCallMessage']) !== null && _a !== void 0 ? _a : '',
        endCall: o['endCall'] ? endCallMessageFromJson(o['endCall']) : undefined,
    };
}
export function externalReferenceToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function externalReferenceFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function phoneProvisioningInfoToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.phoneNumberSid !== undefined)
        o['phoneNumberSid'] = m.phoneNumberSid;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.purchaseRequestState !== undefined)
        o['purchaseRequestState'] = m.purchaseRequestState;
    if (m.purchaseChannel !== undefined)
        o['purchaseChannel'] = m.purchaseChannel;
    if (m.requestedAt !== undefined)
        o['requestedAt'] = m.requestedAt.toISOString();
    if (m.provisionedAt !== undefined)
        o['provisionedAt'] = m.provisionedAt.toISOString();
    if (m.requestFailureReason !== undefined)
        o['requestFailureReason'] = m.requestFailureReason;
    if (m.requestAttemptCount !== undefined)
        o['requestAttemptCount'] = m.requestAttemptCount;
    if (m.notificationState !== undefined)
        o['notificationState'] = m.notificationState;
    if (m.notifiedAt !== undefined)
        o['notifiedAt'] = m.notifiedAt.toISOString();
    if (m.notificationAttemptCount !== undefined)
        o['notificationAttemptCount'] = m.notificationAttemptCount;
    if (m.notificationFailureReason !== undefined)
        o['notificationFailureReason'] = m.notificationFailureReason;
    if (m.requestExternalRef !== undefined) {
        o['requestExternalRef'] = m.requestExternalRef.map(e => externalReferenceToJson(e));
    }
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.lifecycleState !== undefined)
        o['lifecycleState'] = m.lifecycleState;
    if (m.replacedById !== undefined)
        o['replacedById'] = m.replacedById;
    if (m.releaseReason !== undefined)
        o['releaseReason'] = m.releaseReason;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function phoneProvisioningInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
        phoneNumberSid: (_c = o['phoneNumberSid']) !== null && _c !== void 0 ? _c : '',
        phoneNumber: (_d = o['phoneNumber']) !== null && _d !== void 0 ? _d : '',
        countryCode: (_e = o['countryCode']) !== null && _e !== void 0 ? _e : '',
        purchaseRequestState: (_f = o['purchaseRequestState']) !== null && _f !== void 0 ? _f : 'PURCHASE_REQUEST_STATE_UNSPECIFIED',
        purchaseChannel: (_g = o['purchaseChannel']) !== null && _g !== void 0 ? _g : 'PURCHASE_CHANNEL_UNSPECIFIED',
        requestedAt: o['requestedAt'] ? new Date(o['requestedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        provisionedAt: o['provisionedAt'] ? new Date(o['provisionedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        requestFailureReason: (_h = o['requestFailureReason']) !== null && _h !== void 0 ? _h : '',
        requestAttemptCount: (_j = o['requestAttemptCount']) !== null && _j !== void 0 ? _j : 0,
        notificationState: (_k = o['notificationState']) !== null && _k !== void 0 ? _k : 'NOTIFICATION_STATE_UNSPECIFIED',
        notifiedAt: o['notifiedAt'] ? new Date(o['notifiedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        notificationAttemptCount: (_l = o['notificationAttemptCount']) !== null && _l !== void 0 ? _l : 0,
        notificationFailureReason: (_m = o['notificationFailureReason']) !== null && _m !== void 0 ? _m : '',
        requestExternalRef: ((_o = o['requestExternalRef']) !== null && _o !== void 0 ? _o : []).map(e => externalReferenceFromJson(e)),
        source: (_p = o['source']) !== null && _p !== void 0 ? _p : 'SOURCE_UNSPECIFIED',
        lifecycleState: (_q = o['lifecycleState']) !== null && _q !== void 0 ? _q : 'LIFECYCLE_STATE_UNSPECIFIED',
        replacedById: (_r = o['replacedById']) !== null && _r !== void 0 ? _r : '',
        releaseReason: (_s = o['releaseReason']) !== null && _s !== void 0 ? _s : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function mediaToJson(m) {
    const o = {};
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.locationPath !== undefined)
        o['locationPath'] = m.locationPath;
    if (m.fileName !== undefined)
        o['fileName'] = m.fileName;
    return o;
}
export function mediaFromJson(o) {
    var _a, _b, _c;
    return {
        contentType: (_a = o['contentType']) !== null && _a !== void 0 ? _a : '',
        locationPath: (_b = o['locationPath']) !== null && _b !== void 0 ? _b : '',
        fileName: (_c = o['fileName']) !== null && _c !== void 0 ? _c : '',
    };
}
export function sendMessageRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    if (m.recipientPhoneNumber !== undefined)
        o['recipientPhoneNumber'] = m.recipientPhoneNumber;
    if (m.messageBody !== undefined)
        o['messageBody'] = m.messageBody;
    if (m.media !== undefined) {
        o['media'] = m.media.map(e => mediaToJson(e));
    }
    return o;
}
export function sendMessageRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
        recipientPhoneNumber: (_c = o['recipientPhoneNumber']) !== null && _c !== void 0 ? _c : '',
        messageBody: (_d = o['messageBody']) !== null && _d !== void 0 ? _d : '',
        media: ((_e = o['media']) !== null && _e !== void 0 ? _e : []).map(e => mediaFromJson(e)),
    };
}
export function sendMessageResponseToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.conversationId !== undefined)
        o['conversationId'] = m.conversationId;
    return o;
}
export function sendMessageResponseFromJson(o) {
    var _a, _b;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
        conversationId: (_b = o['conversationId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createSmsClickedEventRequestToJson(m) {
    const o = {};
    if (m.messageUuid !== undefined)
        o['messageUuid'] = m.messageUuid;
    return o;
}
export function createSmsClickedEventRequestFromJson(o) {
    var _a;
    return {
        messageUuid: (_a = o['messageUuid']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getAccountInfoRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = participantToJson(m.sender);
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function getAccountInfoRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? participantFromJson(o['sender']) : undefined,
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getAccountInfoResponseToJson(m) {
    const o = {};
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.subaccountId !== undefined)
        o['subaccountId'] = m.subaccountId;
    if (m.alphanumericSenderId !== undefined)
        o['alphanumericSenderId'] = m.alphanumericSenderId;
    return o;
}
export function getAccountInfoResponseFromJson(o) {
    var _a, _b, _c;
    return {
        phoneNumber: (_a = o['phoneNumber']) !== null && _a !== void 0 ? _a : '',
        subaccountId: (_b = o['subaccountId']) !== null && _b !== void 0 ? _b : '',
        alphanumericSenderId: (_c = o['alphanumericSenderId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function senderToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    return o;
}
export function senderFromJson(o) {
    var _a, _b, _c;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        namespace: (_c = o['namespace']) !== null && _c !== void 0 ? _c : '',
    };
}
export function recipientToJson(m) {
    const o = {};
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    return o;
}
export function recipientFromJson(o) {
    var _a;
    return {
        phoneNumber: (_a = o['phoneNumber']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendMessageV2RequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipient !== undefined)
        o['recipient'] = recipientToJson(m.recipient);
    if (m.messageBody !== undefined)
        o['messageBody'] = m.messageBody;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.mediaUrls !== undefined) {
        o['mediaUrls'] = m.mediaUrls.map(e => e);
    }
    return o;
}
export function sendMessageV2RequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipient: o['recipient'] ? recipientFromJson(o['recipient']) : undefined,
        messageBody: (_a = o['messageBody']) !== null && _a !== void 0 ? _a : '',
        attributes: ((_b = o['attributes']) !== null && _b !== void 0 ? _b : []).map(e => attributeFromJson(e)),
        idempotencyKey: (_c = o['idempotencyKey']) !== null && _c !== void 0 ? _c : '',
        mediaUrls: ((_d = o['mediaUrls']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function sendMessageV2ResponseToJson(m) {
    const o = {};
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    return o;
}
export function sendMessageV2ResponseFromJson(o) {
    var _a;
    return {
        messageId: (_a = o['messageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRegulationFormsRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    return o;
}
export function getRegulationFormsRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
    };
}
export function regulationFormToJson(m) {
    const o = {};
    if (m.formId !== undefined)
        o['formId'] = m.formId;
    return o;
}
export function regulationFormFromJson(o) {
    var _a;
    return {
        formId: (_a = o['formId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRegulationFormsResponseToJson(m) {
    const o = {};
    if (m.regulationForms !== undefined) {
        o['regulationForms'] = m.regulationForms.map(e => regulationFormToJson(e));
    }
    return o;
}
export function getRegulationFormsResponseFromJson(o) {
    var _a;
    return {
        regulationForms: ((_a = o['regulationForms']) !== null && _a !== void 0 ? _a : []).map(e => regulationFormFromJson(e)),
    };
}
export function getRegulationInfoRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function getRegulationInfoRequestFromJson(o) {
    var _a;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRegulationInfoResponseToJson(m) {
    const o = {};
    if (m.regulationInfo !== undefined)
        o['regulationInfo'] = regulationInfoToJson(m.regulationInfo);
    return o;
}
export function getRegulationInfoResponseFromJson(o) {
    return {
        regulationInfo: o['regulationInfo'] ? regulationInfoFromJson(o['regulationInfo']) : undefined,
    };
}
export function listRegulationInfoRequestToJson(m) {
    const o = {};
    if (m.filter !== undefined)
        o['filter'] = listRegulationInfoRequestFilterToJson(m.filter);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listRegulationInfoRequestFromJson(o) {
    return {
        filter: o['filter'] ? listRegulationInfoRequestFilterFromJson(o['filter']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listRegulationInfoRequestFilterToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    return o;
}
export function listRegulationInfoRequestFilterFromJson(o) {
    var _a, _b;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'REGULATION_STATUS_UNSPECIFIED',
        countryCode: o['countryCode'],
        ownerId: o['ownerId'],
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
    };
}
export function listRegulationInfoResponseToJson(m) {
    const o = {};
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => regulationInfoToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listRegulationInfoResponseFromJson(o) {
    var _a;
    return {
        items: ((_a = o['items']) !== null && _a !== void 0 ? _a : []).map(e => regulationInfoFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function claimPhoneNumberRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    return o;
}
export function claimPhoneNumberRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
    };
}
export function createA2PRegistrationInfoRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.business !== undefined)
        o['business'] = businessToJson(m.business);
    if (m.authorizedRepresentative !== undefined)
        o['authorizedRepresentative'] = authorizedRepresentativeToJson(m.authorizedRepresentative);
    if (m.submitted !== undefined)
        o['submitted'] = m.submitted;
    if (m.campaignInfo !== undefined)
        o['campaignInfo'] = campaignInfoToJson(m.campaignInfo);
    return o;
}
export function createA2PRegistrationInfoRequestFromJson(o) {
    var _a, _b, _c;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        business: o['business'] ? businessFromJson(o['business']) : undefined,
        authorizedRepresentative: o['authorizedRepresentative'] ? authorizedRepresentativeFromJson(o['authorizedRepresentative']) : undefined,
        submitted: (_c = o['submitted']) !== null && _c !== void 0 ? _c : false,
        campaignInfo: o['campaignInfo'] ? campaignInfoFromJson(o['campaignInfo']) : undefined,
    };
}
export function getA2PRegistrationInfoRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function getA2PRegistrationInfoRequestFromJson(o) {
    var _a;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getA2PRegistrationInfoResponseToJson(m) {
    const o = {};
    if (m.a2pRegistrationInfo !== undefined)
        o['a2pRegistrationInfo'] = a2PRegistrationInfoToJson(m.a2pRegistrationInfo);
    return o;
}
export function getA2PRegistrationInfoResponseFromJson(o) {
    return {
        a2pRegistrationInfo: o['a2pRegistrationInfo'] ? a2PRegistrationInfoFromJson(o['a2pRegistrationInfo']) : undefined,
    };
}
export function deleteA2PRegistrationInfoRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function deleteA2PRegistrationInfoRequestFromJson(o) {
    var _a;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function upsertA2PRegistrationInfoRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.business !== undefined)
        o['business'] = businessToJson(m.business);
    if (m.authorizedRepresentative !== undefined)
        o['authorizedRepresentative'] = authorizedRepresentativeToJson(m.authorizedRepresentative);
    if (m.submitted !== undefined)
        o['submitted'] = m.submitted;
    if (m.campaignInfo !== undefined)
        o['campaignInfo'] = campaignInfoToJson(m.campaignInfo);
    return o;
}
export function upsertA2PRegistrationInfoRequestFromJson(o) {
    var _a, _b, _c;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        business: o['business'] ? businessFromJson(o['business']) : undefined,
        authorizedRepresentative: o['authorizedRepresentative'] ? authorizedRepresentativeFromJson(o['authorizedRepresentative']) : undefined,
        submitted: (_c = o['submitted']) !== null && _c !== void 0 ? _c : false,
        campaignInfo: o['campaignInfo'] ? campaignInfoFromJson(o['campaignInfo']) : undefined,
    };
}
export function getLatestA2PRegistrationStatusRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.subaccountId !== undefined)
        o['subaccountId'] = m.subaccountId;
    return o;
}
export function getLatestA2PRegistrationStatusRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        subaccountId: (_b = o['subaccountId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getLatestA2PRegistrationStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = a2PRegistrationStatusToJson(m.status);
    return o;
}
export function getLatestA2PRegistrationStatusResponseFromJson(o) {
    return {
        status: o['status'] ? a2PRegistrationStatusFromJson(o['status']) : undefined,
    };
}
export function triggerA2PRegistrationRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.campaignDescription !== undefined)
        o['campaignDescription'] = m.campaignDescription;
    if (m.userConsentExplanation !== undefined)
        o['userConsentExplanation'] = m.userConsentExplanation;
    return o;
}
export function triggerA2PRegistrationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        campaignDescription: (_b = o['campaignDescription']) !== null && _b !== void 0 ? _b : '',
        userConsentExplanation: (_c = o['userConsentExplanation']) !== null && _c !== void 0 ? _c : '',
    };
}
export function updateA2PRegistrationStatusRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function updateA2PRegistrationStatusRequestFromJson(o) {
    var _a;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateA2PRegistrationStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = a2PRegistrationStatusToJson(m.status);
    if (m.wasUpdated !== undefined)
        o['wasUpdated'] = m.wasUpdated;
    return o;
}
export function updateA2PRegistrationStatusResponseFromJson(o) {
    var _a;
    return {
        status: o['status'] ? a2PRegistrationStatusFromJson(o['status']) : undefined,
        wasUpdated: (_a = o['wasUpdated']) !== null && _a !== void 0 ? _a : false,
    };
}
export function createRegulationInfoRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.businessAttributes !== undefined) {
        o['businessAttributes'] = m.businessAttributes.map(e => attributeToJson(e));
    }
    if (m.supportingDocuments !== undefined) {
        o['supportingDocuments'] = m.supportingDocuments.map(e => supportingDocumentInfoToJson(e));
    }
    return o;
}
export function createRegulationInfoRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        ownerType: (_c = o['ownerType']) !== null && _c !== void 0 ? _c : 'OWNER_TYPE_UNSPECIFIED',
        countryCode: (_d = o['countryCode']) !== null && _d !== void 0 ? _d : '',
        businessAttributes: ((_e = o['businessAttributes']) !== null && _e !== void 0 ? _e : []).map(e => attributeFromJson(e)),
        supportingDocuments: ((_f = o['supportingDocuments']) !== null && _f !== void 0 ? _f : []).map(e => supportingDocumentInfoFromJson(e)),
    };
}
export function createRegulationInfoResponseToJson(m) {
    const o = {};
    if (m.regulationInfoId !== undefined)
        o['regulationInfoId'] = m.regulationInfoId;
    return o;
}
export function createRegulationInfoResponseFromJson(o) {
    var _a;
    return {
        regulationInfoId: (_a = o['regulationInfoId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRegulationStatusRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    return o;
}
export function getRegulationStatusRequestFromJson(o) {
    var _a;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getRegulationStatusResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function getRegulationStatusResponseFromJson(o) {
    var _a;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'REGULATION_STATUS_UNSPECIFIED',
    };
}
export function getLimitRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.limitType !== undefined)
        o['limitType'] = m.limitType;
    return o;
}
export function getLimitRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        limitType: (_c = o['limitType']) !== null && _c !== void 0 ? _c : 'LIMIT_TYPE_UNSPECIFIED',
    };
}
export function getLimitResponseToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.limitType !== undefined)
        o['limitType'] = m.limitType;
    if (m.usage !== undefined)
        o['usage'] = m.usage;
    if (m.limit !== undefined)
        o['limit'] = m.limit;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function getLimitResponseFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        limitType: (_c = o['limitType']) !== null && _c !== void 0 ? _c : 'LIMIT_TYPE_UNSPECIFIED',
        usage: (_d = o['usage']) !== null && _d !== void 0 ? _d : 0,
        limit: (_e = o['limit']) !== null && _e !== void 0 ? _e : 0,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function canSendSmsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    return o;
}
export function canSendSmsRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
    };
}
export function canSendSmsResponseToJson(m) {
    const o = {};
    if (m.canSendSms !== undefined)
        o['canSendSms'] = m.canSendSms;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    return o;
}
export function canSendSmsResponseFromJson(o) {
    var _a, _b;
    return {
        canSendSms: (_a = o['canSendSms']) !== null && _a !== void 0 ? _a : false,
        reason: (_b = o['reason']) !== null && _b !== void 0 ? _b : 'CAN_SEND_REASON_UNSPECIFIED',
    };
}
export function getPhoneNumberConfigRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    return o;
}
export function getPhoneNumberConfigRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
    };
}
export function getPhoneNumberConfigResponseToJson(m) {
    const o = {};
    if (m.phoneNumberConfig !== undefined)
        o['phoneNumberConfig'] = phoneNumberConfigToJson(m.phoneNumberConfig);
    return o;
}
export function getPhoneNumberConfigResponseFromJson(o) {
    return {
        phoneNumberConfig: o['phoneNumberConfig'] ? phoneNumberConfigFromJson(o['phoneNumberConfig']) : undefined,
    };
}
export function upsertPhoneNumberConfigRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.phoneNumberConfig !== undefined)
        o['phoneNumberConfig'] = phoneNumberConfigToJson(m.phoneNumberConfig);
    return o;
}
export function upsertPhoneNumberConfigRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        phoneNumberConfig: o['phoneNumberConfig'] ? phoneNumberConfigFromJson(o['phoneNumberConfig']) : undefined,
    };
}
export function releasePhoneNumberRequestToJson(m) {
    const o = {};
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.ownerType !== undefined)
        o['ownerType'] = m.ownerType;
    if (m.number !== undefined) {
        if (m.number.type === 'phoneNumber') {
            o['phoneNumber'] = m.number.phoneNumber;
        }
        if (m.number.type === 'phoneNumberSid') {
            o['phoneNumberSid'] = m.number.phoneNumberSid;
        }
    }
    else {
        if (m.phoneNumber !== undefined)
            o['phoneNumber'] = m.phoneNumber;
        if (m.phoneNumberSid !== undefined)
            o['phoneNumberSid'] = m.phoneNumberSid;
    }
    return o;
}
export function releasePhoneNumberRequestFromJson(o) {
    var _a, _b;
    return {
        ownerId: (_a = o['ownerId']) !== null && _a !== void 0 ? _a : '',
        ownerType: (_b = o['ownerType']) !== null && _b !== void 0 ? _b : 'OWNER_TYPE_UNSPECIFIED',
        number: (() => {
            if (o['phoneNumber'] !== undefined)
                return { type: 'phoneNumber', phoneNumber: o['phoneNumber'] };
            if (o['phoneNumberSid'] !== undefined)
                return { type: 'phoneNumberSid', phoneNumberSid: o['phoneNumberSid'] };
            return undefined;
        })(),
        phoneNumber: o['phoneNumber'] !== undefined ? o['phoneNumber'] : undefined,
        phoneNumberSid: o['phoneNumberSid'] !== undefined ? o['phoneNumberSid'] : undefined,
    };
}
export function listSMSEventsRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.filters !== undefined)
        o['filters'] = listSMSEventsRequestFilterToJson(m.filters);
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    return o;
}
export function listSMSEventsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        filters: o['filters'] ? listSMSEventsRequestFilterFromJson(o['filters']) : undefined,
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listSMSEventsRequestFilterToJson(m) {
    const o = {};
    if (m.startTime !== undefined)
        o['startTime'] = m.startTime.toISOString();
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime.toISOString();
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.messageUuid !== undefined)
        o['messageUuid'] = m.messageUuid;
    return o;
}
export function listSMSEventsRequestFilterFromJson(o) {
    var _a, _b;
    return {
        startTime: o['startTime'] ? new Date(o['startTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        endTime: o['endTime'] ? new Date(o['endTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'STATUS_TYPE_UNSPECIFIED',
        messageUuid: (_b = o['messageUuid']) !== null && _b !== void 0 ? _b : '',
    };
}
export function sMSAttributeToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function sMSAttributeFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function sMSEventToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.messageSid !== undefined)
        o['messageSid'] = m.messageSid;
    if (m.messageStatus !== undefined)
        o['messageStatus'] = m.messageStatus;
    if (m.recipient !== undefined)
        o['recipient'] = m.recipient;
    if (m.sender !== undefined)
        o['sender'] = m.sender;
    if (m.apiVersion !== undefined)
        o['apiVersion'] = m.apiVersion;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => sMSAttributeToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.errorCode !== undefined)
        o['errorCode'] = m.errorCode;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    return o;
}
export function sMSEventFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        messageSid: (_b = o['messageSid']) !== null && _b !== void 0 ? _b : '',
        messageStatus: (_c = o['messageStatus']) !== null && _c !== void 0 ? _c : 'STATUS_TYPE_UNSPECIFIED',
        recipient: (_d = o['recipient']) !== null && _d !== void 0 ? _d : '',
        sender: (_e = o['sender']) !== null && _e !== void 0 ? _e : '',
        apiVersion: (_f = o['apiVersion']) !== null && _f !== void 0 ? _f : '',
        attributes: ((_g = o['attributes']) !== null && _g !== void 0 ? _g : []).map(e => sMSAttributeFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        errorCode: (_h = o['errorCode']) !== null && _h !== void 0 ? _h : 0,
        eventId: (_j = o['eventId']) !== null && _j !== void 0 ? _j : '',
    };
}
export function listSMSEventsResponseToJson(m) {
    const o = {};
    if (m.smsEvents !== undefined) {
        o['smsEvents'] = m.smsEvents.map(e => sMSEventToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listSMSEventsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        smsEvents: ((_a = o['smsEvents']) !== null && _a !== void 0 ? _a : []).map(e => sMSEventFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function consentToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function consentFromJson(o) {
    var _a, _b;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'CONSENT_TYPE_UNSPECIFIED',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'CONSENT_STATUS_UNSPECIFIED',
    };
}
export function getConsentPreferencesRequestToJson(m) {
    const o = {};
    if (m.token !== undefined)
        o['token'] = m.token;
    return o;
}
export function getConsentPreferencesRequestFromJson(o) {
    var _a;
    return {
        token: (_a = o['token']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getConsentPreferencesResponseToJson(m) {
    const o = {};
    if (m.consents !== undefined) {
        o['consents'] = m.consents.map(e => consentToJson(e));
    }
    if (m.senderName !== undefined)
        o['senderName'] = m.senderName;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    return o;
}
export function getConsentPreferencesResponseFromJson(o) {
    var _a, _b, _c;
    return {
        consents: ((_a = o['consents']) !== null && _a !== void 0 ? _a : []).map(e => consentFromJson(e)),
        senderName: (_b = o['senderName']) !== null && _b !== void 0 ? _b : '',
        logoUrl: (_c = o['logoUrl']) !== null && _c !== void 0 ? _c : '',
    };
}
export function updateConsentPreferencesRequestToJson(m) {
    const o = {};
    if (m.token !== undefined)
        o['token'] = m.token;
    if (m.consent !== undefined)
        o['consent'] = consentToJson(m.consent);
    return o;
}
export function updateConsentPreferencesRequestFromJson(o) {
    var _a;
    return {
        token: (_a = o['token']) !== null && _a !== void 0 ? _a : '',
        consent: o['consent'] ? consentFromJson(o['consent']) : undefined,
    };
}
export function updateConsentPreferencesResponseToJson(m) {
    const o = {};
    return o;
}
export function updateConsentPreferencesResponseFromJson(o) {
    return {};
}
export function statusStatToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function statusStatFromJson(o) {
    var _a, _b;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'STATUS_TYPE_UNSPECIFIED',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function getAttributeEventStatsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    return o;
}
export function getAttributeEventStatsRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
    };
}
export function getAttributeEventStatsResponseToJson(m) {
    const o = {};
    if (m.stats !== undefined) {
        o['stats'] = m.stats.map(e => statusStatToJson(e));
    }
    return o;
}
export function getAttributeEventStatsResponseFromJson(o) {
    var _a;
    return {
        stats: ((_a = o['stats']) !== null && _a !== void 0 ? _a : []).map(e => statusStatFromJson(e)),
    };
}
export function getMultiPhoneProvisioningInfoRequestToJson(m) {
    const o = {};
    if (m.ids !== undefined) {
        o['ids'] = m.ids.map(e => e);
    }
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function getMultiPhoneProvisioningInfoRequestFromJson(o) {
    var _a, _b;
    return {
        ids: ((_a = o['ids']) !== null && _a !== void 0 ? _a : []).map(e => e),
        accountGroupId: (_b = o['accountGroupId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMultiPhoneProvisioningInfoResponseToJson(m) {
    const o = {};
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => phoneProvisioningInfoToJson(e));
    }
    return o;
}
export function getMultiPhoneProvisioningInfoResponseFromJson(o) {
    var _a;
    return {
        items: ((_a = o['items']) !== null && _a !== void 0 ? _a : []).map(e => phoneProvisioningInfoFromJson(e)),
    };
}
export function listPhoneProvisioningInfoRequestToJson(m) {
    const o = {};
    if (m.filter !== undefined)
        o['filter'] = listPhoneProvisioningInfoRequestFilterToJson(m.filter);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listPhoneProvisioningInfoRequestFromJson(o) {
    return {
        filter: o['filter'] ? listPhoneProvisioningInfoRequestFilterFromJson(o['filter']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listPhoneProvisioningInfoRequestFilterToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.lifecycleState !== undefined)
        o['lifecycleState'] = m.lifecycleState;
    if (m.purchaseRequestState !== undefined)
        o['purchaseRequestState'] = m.purchaseRequestState;
    if (m.notificationState !== undefined)
        o['notificationState'] = m.notificationState;
    return o;
}
export function listPhoneProvisioningInfoRequestFilterFromJson(o) {
    var _a, _b, _c;
    return {
        accountGroupId: o['accountGroupId'],
        countryCode: o['countryCode'],
        lifecycleState: (_a = o['lifecycleState']) !== null && _a !== void 0 ? _a : 'LIFECYCLE_STATE_UNSPECIFIED',
        purchaseRequestState: (_b = o['purchaseRequestState']) !== null && _b !== void 0 ? _b : 'PURCHASE_REQUEST_STATE_UNSPECIFIED',
        notificationState: (_c = o['notificationState']) !== null && _c !== void 0 ? _c : 'NOTIFICATION_STATE_UNSPECIFIED',
    };
}
export function listPhoneProvisioningInfoResponseToJson(m) {
    const o = {};
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => phoneProvisioningInfoToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listPhoneProvisioningInfoResponseFromJson(o) {
    var _a;
    return {
        items: ((_a = o['items']) !== null && _a !== void 0 ? _a : []).map(e => phoneProvisioningInfoFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function createPhoneProvisioningInfoRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.countryCode !== undefined)
        o['countryCode'] = m.countryCode;
    if (m.purchaseChannel !== undefined)
        o['purchaseChannel'] = m.purchaseChannel;
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.purchaseRequestState !== undefined)
        o['purchaseRequestState'] = m.purchaseRequestState;
    if (m.phoneNumberSid !== undefined)
        o['phoneNumberSid'] = m.phoneNumberSid;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.requestExternalRef !== undefined) {
        o['requestExternalRef'] = m.requestExternalRef.map(e => externalReferenceToJson(e));
    }
    return o;
}
export function createPhoneProvisioningInfoRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        countryCode: (_b = o['countryCode']) !== null && _b !== void 0 ? _b : '',
        purchaseChannel: (_c = o['purchaseChannel']) !== null && _c !== void 0 ? _c : 'PURCHASE_CHANNEL_UNSPECIFIED',
        source: (_d = o['source']) !== null && _d !== void 0 ? _d : 'SOURCE_UNSPECIFIED',
        purchaseRequestState: (_e = o['purchaseRequestState']) !== null && _e !== void 0 ? _e : 'PURCHASE_REQUEST_STATE_UNSPECIFIED',
        phoneNumberSid: (_f = o['phoneNumberSid']) !== null && _f !== void 0 ? _f : '',
        phoneNumber: (_g = o['phoneNumber']) !== null && _g !== void 0 ? _g : '',
        requestExternalRef: ((_h = o['requestExternalRef']) !== null && _h !== void 0 ? _h : []).map(e => externalReferenceFromJson(e)),
    };
}
export function createPhoneProvisioningInfoResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createPhoneProvisioningInfoResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updatePhoneProvisioningInfoRequestToJson(m) {
    const o = {};
    if (m.phoneProvisioningInfo !== undefined)
        o['phoneProvisioningInfo'] = phoneProvisioningInfoToJson(m.phoneProvisioningInfo);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updatePhoneProvisioningInfoRequestFromJson(o) {
    return {
        phoneProvisioningInfo: o['phoneProvisioningInfo'] ? phoneProvisioningInfoFromJson(o['phoneProvisioningInfo']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
